import { Box } from 'braid-design-system';
import { memo, useEffect } from 'react';

import { SafetyHelmet } from 'src/components/SafetyHelmet/SafetyHelmet';
import { useZoneFeatures } from 'src/config/appConfig';
import { SearchResultPage } from 'src/handlers/SearchResults';
import {
  PageTitle,
  useSetHubblePage,
  useSetHubbleTags,
} from 'src/modules/hubble';
import { useHomePageHead } from 'src/modules/seo-header/home-page/head';
import { useSavedAndRecentSearchesFeatureFlag } from 'src/store/featureFlags/hooks';
import { useSelector } from 'src/store/react';
import {
  selectUserTestHeaders,
  selectAuthenticated,
} from 'src/store/selectors';

import { CPCarousel } from './CPCarousel/CPCarousel';
import Dashboard from './Dashboard/Dashboard';
import HomePageBanner from './HomePageBanner/HomePageBanner';
import QuickSearch from './QuickSearch/QuickSearch';
import RecentSearchesBar from './RecentSearches/RecentSearchesBar';

import * as styles from './HomePage.css';

const sectionSpace = 'xxxlarge';

export const HOMEPAGE_CONTENT_DATA_AUTOMATION = 'homePage';

const HomePage = () => {
  useSetHubblePage(PageTitle.homePage);
  const testHeaders = useSelector(selectUserTestHeaders);
  const isAuthenticated = useSelector(selectAuthenticated);
  useSetHubbleTags(testHeaders);
  const { HOMEPAGE_BANNER_TYPE: homepageBannerType } = useZoneFeatures();

  useEffect(() => {
    SearchResultPage.preload();
  }, []);

  const isSavedAndRecentSearches = useSavedAndRecentSearchesFeatureFlag();

  const { meta, link, script, title } = useHomePageHead();

  const dashboardPadding = isAuthenticated ? 'xlarge' : 'xxlarge';

  return (
    <Box
      display="flex"
      flexDirection="column"
      data={{ automation: HOMEPAGE_CONTENT_DATA_AUTOMATION }}
    >
      <SafetyHelmet meta={meta} link={link} script={script} title={title} />
      <Box
        display={{ mobile: 'none', tablet: 'block' }}
        paddingTop={sectionSpace}
        className={styles.reorder}
      >
        <QuickSearch />
      </Box>
      {!isSavedAndRecentSearches && <RecentSearchesBar />}
      <Box
        paddingTop={{
          desktop: dashboardPadding,
          mobile: 'medium',
        }}
      >
        <Dashboard />
      </Box>
      {!isAuthenticated && <CPCarousel sectionSpace={sectionSpace} />}

      {homepageBannerType && (
        <Box paddingTop={sectionSpace}>
          <HomePageBanner />
        </Box>
      )}
    </Box>
  );
};

export default memo(HomePage);
